import SyDialog from './index.vue'

const syDialog={
    install:function(Vue){
        if (typeof window !== 'undefined' && window.Vue) {
            Vue = window.Vue
        }
        Vue.component(SyDialog.name,SyDialog);
    }
}

export default syDialog




// WEBPACK FOOTER //
// ./src/components/sy-dialog/index.js